import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, of as observableOf } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppSettings } from '../appSettings';

@Injectable({
  providedIn: 'root',
})
export class SiteService {
  constructor(private _apiService: ApiService) {}

  getParameters(): Observable<any> {
    return this._apiService.doGET('site').pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  storeParameters(data): Observable<any> {
    return this._apiService.doPOST('site', data).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  getUrlLogoOptions() {
    return {
      url: AppSettings.API_ENDPOINT + `site/i/cabecalho`,
      authTokenHeader: 'Authorization',
      authToken: 'Bearer ' + this._apiService.getAccessToken(),
    };
  }

  getUrlFaviconOptions() {
    return {
      url: AppSettings.API_ENDPOINT + `site/i/favicon`,
      authTokenHeader: 'Authorization',
      authToken: 'Bearer ' + this._apiService.getAccessToken(),
    };
  }

  getsocialNetwork(): Observable<any> {
    return this._apiService.doGET('site/social-networks').pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  storesocialNetwork(data): Observable<any> {
    return this._apiService.doPOST('site/social-networks', data).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  storeSubdomain(data): Observable<any> {
    return this._apiService.doPOST('site/subdomain', data).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }
}
